import React from 'react'
import VolunteeringExercisePageOne from './VolunteeringExercisePageOne'
import VolunteeringExercisePageTwo from './VolunteeringExercisePageTwo'
import { useVolunteeringExercise } from './VolunteeringExerciseProvider'

const Page = () => {
  const { section } = useVolunteeringExercise()
  return (
    <div>
      {section === 0 && <VolunteeringExercisePageOne />}
      {section === 1 && <VolunteeringExercisePageTwo />}
    </div>
  )
}
export default Page
